import { useState, useEffect } from "react";

// rAF-throttled "have we scrolled past N px" — one cheap listener, no layout
// thrash. Shared by the header, sticky CTA and floating buttons.
export function useScrolledPast(threshold = 0) {
  const [past, setPast] = useState(false);

  useEffect(() => {
    let ticking = false;
    const update = () => {
      setPast(window.scrollY > threshold);
      ticking = false;
    };
    const onScroll = () => {
      if (!ticking) {
        ticking = true;
        requestAnimationFrame(update);
      }
    };
    update();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, [threshold]);

  return past;
}
